import React from 'react';
import { Tab, Tabs } from '@mui/material';
import { Box, styled } from '@mui/system';
import { Link } from 'react-router-dom';

import { CONTROL_TEXT, HOVER_BG, TEXT_DARK } from '../common/tokens';

const StyledTabs = styled(Tabs)({
  minHeight: 'unset',
  '& .MuiTabs-indicator': {
    bottom: 0,
    height: '1px',
    boxSizing: 'border-box',
    borderLeft: '8px solid transparent',
    borderRight: '8px solid transparent',
    backgroundClip: 'content-box',
  },
});

const StyledTab = styled(Tab)(({ theme }) => ({
  minHeight: 'unset',
  minWidth: 0,
  padding: '5px 8px',
  borderRadius: '6px',
  fontSize: '14.5px',
  fontWeight: 600,
  lineHeight: 1,
  letterSpacing: '.02em',
  opacity: 1,
  color: CONTROL_TEXT,
  '&:hover': { color: TEXT_DARK, backgroundColor: HOVER_BG },
  '&.Mui-selected': { opacity: 1, fontWeight: 700, color: theme.palette.primary.main },
}));

const TabCount = styled('span')(({ theme }) => ({
  marginLeft: '6px',
  padding: '2px 6px',
  borderRadius: '6px',
  background: theme.palette.primary.main,
  color: '#fff',
  fontSize: 11,
  fontWeight: 700,
  letterSpacing: 'normal',
  lineHeight: 1,
}));

// Which tab the current route selects, or undefined on a route that owns no
// tab — there the previous selection stands.
function tabForPath(pathname, isModerate, moderationMode) {
  if (pathname.startsWith('/explore')) return 1;
  if (pathname.startsWith('/share')) return 2;
  if (pathname.startsWith('/learn')) return 0;
  if (isModerate) {
    // Highlight the Moderate tab when it's shown; if the queue emptied the tab is
    // gone (and a redirect is pending).
    return moderationMode ? 3 : false;
  }
  return undefined;
}

/**
 * The header's primary navigation. The route drives the selection, but it is
 * held in state so a route that owns no tab — an item page, say — leaves the
 * last selection standing rather than clearing it.
 */
export default function NavTabs({
  pathname, isModerate, moderationMode, pendingTotal,
}) {
  const [tabValue, setTabValue] = React.useState(1);

  const routeTab = tabForPath(pathname, isModerate, moderationMode);
  if (tabValue !== routeTab && routeTab !== undefined) {
    setTabValue(routeTab);
  }

  return (
    <StyledTabs
      textColor="inherit"
      value={tabValue}
      onChange={(event, newValue) => setTabValue(newValue)}
    >
      <StyledTab component={Link} label="Learn" to="/learn" />
      <StyledTab component={Link} label="Explore" to="/explore" />
      <StyledTab component={Link} label="Share" to="/share" />
      {moderationMode && (
        <StyledTab
          component={Link}
          to="/moderate/items"
          label={(
            <Box sx={{ display: 'inline-flex', alignItems: 'center' }}>
              Moderate
              <TabCount>{pendingTotal}</TabCount>
            </Box>
          )}
        />
      )}
    </StyledTabs>
  );
}
